import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "onPress", "onFocus", "onBlur", "variant", "size", "autoFocus"];
import styled from 'styled-components';
import { useRef } from 'react';
import { useButton, mergeProps } from 'react-aria';
import { useTrellisFocusRing } from '../../hooks/useTrellisFocusRing';
import { Flex } from '../Flex';
import { getVariantTokens } from './CloseButton.helpers';
import { getSizeTokens } from './CloseButton.helpers';
import { useSizeCssObject, useVariantCssObject } from './CloseButton.hooks';
import { RemoveIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCloseButton = styled.button.withConfig({
  displayName: "CloseButton__StyledCloseButton",
  componentId: "wvskxy-0"
})(({
  $variantCssStyles,
  $focusRingStyles,
  $sizeCssStyles
}) => {
  return Object.assign({
    //  Reseting all non-inherited properties to initial
    all: 'unset',
    cursor: 'pointer'
  }, $variantCssStyles, $focusRingStyles, $sizeCssStyles);
});
export function CloseButton(_ref) {
  let {
      disabled = false,
      onPress = () => {},
      onFocus = () => {},
      onBlur = () => {},
      variant = 'default',
      size = 'medium',
      autoFocus = false
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const handlePress = () => {
    if (disabled) return;
    onPress();
  };
  const handleFocus = () => {
    onFocus();
  };
  const handleBlur = () => {
    onBlur();
  };
  const variantTokens = getVariantTokens(variant);
  const variantCssStyles = useVariantCssObject(variantTokens);
  const {
    focusRingStyles,
    focusProps
  } = useTrellisFocusRing({
    autoFocus
  });
  const sizeTokens = getSizeTokens(size);
  const sizeCssStyles = useSizeCssObject(sizeTokens);
  const buttonRef = useRef(null);
  const {
    buttonProps
  } = useButton(Object.assign({}, props, {
    autoFocus,
    onPress: handlePress,
    onFocus: handleFocus,
    onBlur: handleBlur
  }), buttonRef);
  const mergedProps = mergeProps(buttonProps, focusProps);
  return /*#__PURE__*/_jsx(StyledCloseButton, Object.assign({}, mergedProps, {
    ref: buttonRef,
    "aria-disabled": disabled ? true : undefined,
    $variantCssStyles: variantCssStyles,
    $focusRingStyles: focusRingStyles,
    $sizeCssStyles: sizeCssStyles,
    children: /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "row",
      as: "span",
      blockSize: "100%",
      children: /*#__PURE__*/_jsx(RemoveIcon, {
        size: sizeTokens.iconSize
      })
    })
  }));
}